import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IApiResponse,
  IFilterPaginationDto,
  IRewardDto,
  IRewardSettingDto,
} from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class RewardService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getRewardList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IRewardDto[]> {
    return this.post(`admin/reward/list/${id}`, model);
  }

  public getRewardSettings(id: number): Observable<IRewardSettingDto> {
    return this.get(`admin/reward/${id}`);
  }

  public updateRewardSettings(
    model: IRewardSettingDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/reward`, model);
  }

  public changeRewardStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/reward/${id}`, null);
  }

  public saveRewardPoints(
    id: number,
    model: KeyValue<number, number>[]
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/reward/${id}`, model);
  }

  public getRewardsBalance(id: number): Observable<IApiResponse<number>> {
    return this.get(`admin/reward/balance/${id}`);
  }
}
